import React, { useEffect } from "react";
import AuthenticatedTemplate from "../components/AuthenticatedTemplate";
import Header from "../components/Header";
import { SideBar } from "../components/SideBar";
import Breadcrumbs from "../components/Breadcrumbs";
import { FooterDashboard } from "../components/FooterDashboard";
import Button from "../components/form/Button";
import { Link } from "react-router-dom";
import { useGlobalStore } from "../stores/global-store";
import { useMask } from "@react-input/mask";
import Select from "../components/form/Select";

const DashboardLine = () => {
  const { gender, fetchGender } = useGlobalStore();

  const breadcrumbs = [
    {
      name: "Dashboard",
      link: "/dashboard-return",
    },
    {
      name: "Organisation",
    },
  ];

  const phoneRef = useMask({
    mask: "+64 __ ___ ____",
    replacement: { _: /\d/ },
  });

  useEffect(() => {
    fetchGender();
  }, []);

  return (
    <>
      <AuthenticatedTemplate>
        <SideBar />
        <Header title={"Organisation"} breadcrumbs={breadcrumbs} />

        <main className="dashboard">
          <div className="topic-title">
            <h1 className="text-sm text-neutral-950">Organisation</h1>
            <Breadcrumbs items={breadcrumbs} />
          </div>

          <div className="dashboard-line">
            <div className="error-card">
              <h3 className="paragraph-md semibold text-danger-950">
                Action Required
              </h3>
              <p className="paragraph-md text-danger-900">
                Complete your application by entering the recommended details to
                continue.
              </p>
            </div>

            <div className="dashboard-following">
              <h2 className="paragraph-lg semibold text-neutral-950">
                Details
              </h2>
              <div className="dashboard-following__info">
                <p className="small text-neutral">
                  Order number:{" "}
                  <span className="semibold text-neutral-950">{"N/A"}</span>
                </p>
                <p className="small text-neutral">
                  Submission date:{" "}
                  <span className="semibold text-neutral-950">{"N/A"}</span>
                </p>
                <p className="small text-neutral">
                  Status:{" "}
                  <span className="semibold text-neutral-950">In Progress</span>
                </p>
              </div>
            </div>

            <form className="form">
              <div className="form__controller">
                <label htmlFor="clientNumber">Client number</label>
                <input name="clientNumber" id="clientNumber" type="text" />
              </div>
              <div className="form__controller">
                <label htmlFor="emailAddress">Email address</label>
                <input name="emailAddress" id="emailAddress" type="email" />
              </div>
              <div className="form__controller">
                <label htmlFor="phone">Phone</label>
                <input ref={phoneRef} name="phone" id="phone" type="text" />
              </div>
              <div className="form__controller">
                <label htmlFor="address">Address</label>
                <input name="address" id="address" type="text" />
              </div>
              <div className="form__controller">
                <label htmlFor="gender">Gender</label>
                <select name="gender">
                  <option selected="true" disabled="disabled">
                    Select here
                  </option>
                  {gender
                    ? gender.map((item, index) => {
                        return (
                          <option key={index + 100} value={item.Gender_ID}>
                            {item.Gender_Description}
                          </option>
                        );
                      })
                    : null}
                </select>
              </div>
            </form>

            <div className="action-buttons">
              <Link to="/dashboard-return">
                <Button variant="outlined">Cancel</Button>
              </Link>
              <Button variant="primary">Submit</Button>
            </div>
          </div>
        </main>

        <form className="form">
          <div className="form__controller">
            <label htmlFor="clientNumber">Client number</label>
            <input name="clientNumber" id="clientNumber" type="text" />
          </div>
          <div className="form__controller">
            <label htmlFor="emailAddress">Email address</label>
            <input name="emailAddress" id="emailAddress" type="email" />
          </div>
          <div className="form__controller">
            <label htmlFor="phone">Phone</label>
            <input ref={phoneRef} name="phone" id="phone" type="text" />
          </div>
          <div className="form__controller">
            <label htmlFor="address">Address</label>
            <input name="address" id="address" type="text" />
          </div>
          <Select
            items={gender}
            itemText="Gender_Description"
            itemValue="Gender_ID"
            label="Gender"
          />
        </form>

        <div className="action-buttons">
          <Link to="/dashboard-return">
            <Button variant="outlined">Cancel</Button>
          </Link>
          <Button variant="primary">Submit</Button>
        </div>

        <FooterDashboard />
      </AuthenticatedTemplate>
    </>
  );
};

export default DashboardLine;
